/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SupplementActionType } from './SupplementActionType';
import {
    SupplementActionTypeFromJSON,
    SupplementActionTypeFromJSONTyped,
    SupplementActionTypeToJSON,
    SupplementActionTypeToJSONTyped,
} from './SupplementActionType';

/**
 * Payload to create or update a supplement justification. Exactly one of lineItemMatchGroupId or lineItemId must be provided.
 * @export
 * @interface UpsertSupplementJustificationRequest
 */
export interface UpsertSupplementJustificationRequest {
    /**
     * ID of the line item match group (for matched items like underscoped)
     * @type {number}
     * @memberof UpsertSupplementJustificationRequest
     */
    lineItemMatchGroupId?: number | null;
    /**
     * ID of the line item (for unmatched items)
     * @type {number}
     * @memberof UpsertSupplementJustificationRequest
     */
    lineItemId?: number | null;
    /**
     * 
     * @type {SupplementActionType}
     * @memberof UpsertSupplementJustificationRequest
     */
    actionType?: SupplementActionType;
    /**
     * Amount requested for this justification in cents
     * @type {number}
     * @memberof UpsertSupplementJustificationRequest
     */
    amountRequestedCents?: number | null;
    /**
     * AI confidence score for this justification
     * @type {number}
     * @memberof UpsertSupplementJustificationRequest
     */
    confidenceScore?: number | null;
    /**
     * Justification text
     * @type {string}
     * @memberof UpsertSupplementJustificationRequest
     */
    justificationText?: string | null;
    /**
     * AI-generated reasoning for this justification
     * @type {string}
     * @memberof UpsertSupplementJustificationRequest
     */
    aiReasoning?: string | null;
    /**
     * Title of the codebook reference
     * @type {string}
     * @memberof UpsertSupplementJustificationRequest
     */
    codeBookTitle?: string | null;
    /**
     * Chapter within the codebook
     * @type {string}
     * @memberof UpsertSupplementJustificationRequest
     */
    chapter?: string | null;
    /**
     * Relevant snippet from the codebook
     * @type {string}
     * @memberof UpsertSupplementJustificationRequest
     */
    snippet?: string | null;
}



/**
 * Check if a given object implements the UpsertSupplementJustificationRequest interface.
 */
export function instanceOfUpsertSupplementJustificationRequest(value: object): value is UpsertSupplementJustificationRequest {
    return true;
}

export function UpsertSupplementJustificationRequestFromJSON(json: any): UpsertSupplementJustificationRequest {
    return UpsertSupplementJustificationRequestFromJSONTyped(json, false);
}

export function UpsertSupplementJustificationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpsertSupplementJustificationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'lineItemMatchGroupId': json['lineItemMatchGroupId'] == null ? undefined : json['lineItemMatchGroupId'],
        'lineItemId': json['lineItemId'] == null ? undefined : json['lineItemId'],
        'actionType': json['actionType'] == null ? undefined : SupplementActionTypeFromJSON(json['actionType']),
        'amountRequestedCents': json['amountRequestedCents'] == null ? undefined : json['amountRequestedCents'],
        'confidenceScore': json['confidenceScore'] == null ? undefined : json['confidenceScore'],
        'justificationText': json['justificationText'] == null ? undefined : json['justificationText'],
        'aiReasoning': json['aiReasoning'] == null ? undefined : json['aiReasoning'],
        'codeBookTitle': json['codeBookTitle'] == null ? undefined : json['codeBookTitle'],
        'chapter': json['chapter'] == null ? undefined : json['chapter'],
        'snippet': json['snippet'] == null ? undefined : json['snippet'],
    };
}

export function UpsertSupplementJustificationRequestToJSON(json: any): UpsertSupplementJustificationRequest {
    return UpsertSupplementJustificationRequestToJSONTyped(json, false);
}

export function UpsertSupplementJustificationRequestToJSONTyped(value?: UpsertSupplementJustificationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lineItemMatchGroupId': value['lineItemMatchGroupId'],
        'lineItemId': value['lineItemId'],
        'actionType': SupplementActionTypeToJSON(value['actionType']),
        'amountRequestedCents': value['amountRequestedCents'],
        'confidenceScore': value['confidenceScore'],
        'justificationText': value['justificationText'],
        'aiReasoning': value['aiReasoning'],
        'codeBookTitle': value['codeBookTitle'],
        'chapter': value['chapter'],
        'snippet': value['snippet'],
    };
}

